export default {
    data() {
        return {
            errors: {},
        }
    },
}
